import React, { Component, Fragment } from 'react';

// types
import PropTypes from 'prop-types';

// components
import ManagementTeamAction from './ManagementTeamAction';

class ManagementTeam extends Component {
  state = {
    managementTeamMember: null,
  };

  toggleManagementTeamDialog = (managementTeamMember) => {
    this.setState({ managementTeamMember });
  };

  render() {
    const { managementTeamMember } = this.state;
    const { users } = this.props;

    // sort management team members by first name
    const orderedUsers = users
      .map((user) => user)
      .sort((a, b) => a.order - b.order);

    // check and filter all approved management team members
    const teamMembers = orderedUsers.filter(
      ({ isManagementUserApproved }) => isManagementUserApproved
    );

    return (
      <Fragment>
        {managementTeamMember && (
          <ManagementTeamAction
            managementTeamMember={managementTeamMember}
            toggleManagementTeamDialog={this.toggleManagementTeamDialog}
          />
        )}
        {!!teamMembers.length && (
          <div className='max-width-div add-margin'>
            <div className='black-44'>Management Team</div>
            <div className='mgt-card-wrapper'>
              {teamMembers.map((user) => {
                const { _id, fullName, position, imageUrl } = user;

                return (
                  <div
                    key={_id}
                    onClick={() => this.toggleManagementTeamDialog(user)}
                    className='card-div'
                    style={{ outline: 'none' }}
                    onKeyDown={(e) =>
                      e.keyCode === 13 && this.toggleManagementTeamDialog(user)
                    }
                    role='link'
                    tabIndex={0}
                  >
                    <div
                      className='card-background-div'
                      style={{
                        backgroundImage: `url(${
                          imageUrl || '/images/default-issuer.png'
                        })`,
                      }}
                    />
                    <div className='card-bottom-white'>
                      <div className='_16-black-label'>{position}</div>
                      <div className='team-name'>{fullName}</div>
                      <div className='card-link'>Read Biography</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

ManagementTeam.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ManagementTeam;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ManagementTeam/index.js